<script lang="ts">
  import { getNow, getTimeZone } from "../data/clock";
  import { ensureDate, timeDistance } from "../support/dates";
  import Locale from "./locale.svelte";
  import Timestamp from "./timestamp.svelte";

  export let time = getNow();
  export let timeZone = getTimeZone();
  export let deadline = $time;

  $: goal = ensureDate(deadline);
  $: distance = timeDistance($time, goal);
  $: hours = distance[0];
  $: minutes = distance[1];
</script>

<span>
  {#if $time >= goal}
    <Locale label="countdown.happeningNow" />
  {:else if hours >= 1}
    <Timestamp label="countdown.startingAt" time={goal} {timeZone} />
  {:else if minutes >= 1}
    <Locale label="countdown.startingIn" vars={{ minutes }} />
  {:else}
    <Locale label="countdown.aboutToStart" vars={{ minutes }} />
  {/if}
</span>
